module.exports = __webpack_public_path__ + "img/menu.e031cddc.svg";